/*
*
* File JS componente Search Bar
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './search-bar.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const searchBar = () => {
    let searchToggle = document.querySelector('.search-toggle');

    if (!searchToggle) return;

    searchToggle.addEventListener('click', () => {
        if (body.classList.contains('open-menu-mobile'))
        {
            document.querySelector('.header__burger').click();
        }
    })
}

export default searchBar;

//--------------------------------------------------------------------//